import { setAttributesFilter } from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';

export type Row = {
    value: string;
    tasks: number;
    perc_total: number;
};

export type SetAttributeFilterDataProps = ApiMethodBase & {
    selection: Row[];
};

export const SetAttributeFilterData = ({
    selection,
}: SetAttributeFilterDataProps) => {
    setAttributesFilter(selection);
};
